<template>
  <i class="ivu-icon ivu-icon-ios-refresh" style="color: red"></i>
</template>

<script>
export default {
  name: "asyncLoadingError"
};
</script>
